import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import { notification, logError } from 'redux/modules/app'
import {
  passwords as passwordsApi,
  emails as emailsApi
} from 'redux/modules/api'
import config from 'config'
import { ACCOUNT_TYPES, ACTIVITY_STATES } from '../../../../constants/enums'
import { organizationContactReactivateAccount } from '../../../../redux/modules/api/emails'

function decorator() {
  return ComposedComponent => {
    @connect(null, {
      notification,
      push,
      ...passwordsApi,
      ...emailsApi,
      logError
    })
    class Emails extends Component {
      static propTypes = {
        confirmEmail: PropTypes.func.isRequired,
        reactivateAccount: PropTypes.func.isRequired,
        organizationContactReactivateAccount: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        logError: PropTypes.func.isRequired,
        push: PropTypes.func.isRequired
      }

      handleConfirmEmail = code => {
        this.props
          .confirmEmail(code)
          .then(() => {
            this.props.notification('Email address has been confirmed.', {
              status: 'success',
              intlKey: 'notifications.email_has_been_confirmed'
            })

          this.props.push(`${config.publicPath}/`)
          })
          .catch(this.handleError)
      }


      handleReactivateAccount = (code, type) =>{

      switch(type){
        case ACCOUNT_TYPES.participant.id:
          this.props
            .reactivateAccount(code)
            .then(() => {
              this.props.notification('Account has been re-activated.', {
                status: 'success',
                intlKey: 'notifications.account_has_been_reactivated'
              })

              this.props.push(`${config.publicPath}/`)
            })
            .catch(this.handleError)
          break
        case ACCOUNT_TYPES.organizationStaff.id:
          this.props
            .organizationContactReactivateAccount(code)
            .then(() => {
              this.props.notification('Account has been re-activated.', {
                status: 'success',
                intlKey: 'notifications.account_has_been_reactivated'
              })

              this.props.push(`${config.publicPath}/`)
            })
            .catch(this.handleError)
          break
        default: break
      }

      }


      render() {
        return (
          <ComposedComponent
            {...this.props}
            confirmEmail={this.handleConfirmEmail}
            reactivateAccount={this.handleReactivateAccount}
          />
        )
      }
    }
    return Emails
  }
}

export default decorator
